import { FaComments, FaMapMarkedAlt, FaDraftingCompass, FaBoxOpen, FaHammer, FaCheckCircle, FaHandshake } from 'react-icons/fa';

const process = [
    {
        id: 1,
        icon: <FaComments />, // Planning & Consultation Icon
        title: 'Planning & {Consultation}',
        content: 'We begin with a detailed consultation to understand your vision & budget.',
    },
    {
        id: 2,
        icon: <FaMapMarkedAlt />, // Site Evaluation Icon
        title: 'Site {Evaluation}',
        content: 'Our experts assess the site to determine project specifications.',
    },
    {
        id: 3,
        icon: <FaDraftingCompass />, // Design & Approval Icon
        title: 'Design & {Approval}',
        content: 'We create customized design & obtain necessary approvals.',
    },
    {
        id: 4,
        icon: <FaBoxOpen />, // Material Selection Icon
        title: 'Material {Selection}',
        content: 'We help you choose high-quality construction materials.',
    },
    {
        id: 5,
        icon: <FaHammer />, // Construction & Execution Icon
        title: 'Construction {& Execution}',
        content: 'Our professional team executes the project with precision.',
    },
    {
        id: 6,
        icon: <FaCheckCircle />, // Quality Inspection Icon
        title: 'Quality {Inspection}',
        content: 'We conduct thorough inspections to ensure compliance with safety.',
    },
    {
        id: 7,
        icon: <FaHandshake />, // Project Handover Icon
        title: 'Project {Handover}',
        content: 'Once completed, we finalize the project and hand over on time.',
    },
];

export default process;